import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React, { useState } from 'react';
import { useForm, Field } from 'react-final-form';
import Form from '@piconetworks/pkg-form';
import countries from './countries/index.js';

var _excluded = ["name", "fieldContainerProps", "description", "required", "defaultValue"];
var Address = function Address(_ref) {
  if (_ref === void 0) {
    _ref = {};
  }
  var _ref2 = _ref,
    name = _ref2.name,
    fieldContainerProps = _ref2.fieldContainerProps,
    _ref2$description = _ref2.description,
    description = _ref2$description === void 0 ? null : _ref2$description,
    required = _ref2.required;
    _ref2.defaultValue;
    var rest = _objectWithoutPropertiesLoose(_ref2, _excluded);
  var form = useForm();
  var _useState = useState(null),
    country = _useState[0],
    changeCountry = _useState[1];
  var countryData = countries[country];
  var AddressFields = (countryData === null || countryData === void 0 ? void 0 : countryData.Component) || function () {
    return null;
  };
  var fieldName = name + ".country";
  return /*#__PURE__*/React.createElement(Form.Field, fieldContainerProps, /*#__PURE__*/React.createElement("p", null, description), /*#__PURE__*/React.createElement(Form.Field, {
    label: "Country",
    required: required
  }, /*#__PURE__*/React.createElement(Field, _extends({
    name: fieldName,
    component: function component(props) {
      return /*#__PURE__*/React.createElement(Form.Dropdown, _extends({}, props, {
        input: {
          value: country,
          onChange: function onChange(val) {
            changeCountry(val);
            form.change(fieldName, val);
          },
          onBlur: function onBlur() {}
        }
      }));
    },
    value: country,
    type: "text"
  }, required && {
    validate: function validate(value) {
      return value ? undefined : 'Required';
    }
  }, rest, {
    options: Object.entries(countries).filter(function (_ref3) {
      _ref3[0];
        var _ref3$ = _ref3[1],
        name = _ref3$.name,
        Component = _ref3$.Component;
      return !!name && !!Component;
    }).map(function (_ref4) {
      var key = _ref4[0],
        name = _ref4[1].name;
      return {
        label: name,
        value: key
      };
    })
  }))), /*#__PURE__*/React.createElement(AddressFields, _extends({
    name: name,
    required: required
  }, rest)));
};

export { Address as default };
//# sourceMappingURL=index.js.map
